import React from 'react';
import { HeroSection } from './components/HeroSection';
import { OpeningStory } from './components/OpeningStory';
import { ProblemSection } from './components/ProblemSection';
import { WhySolutionsFail } from './components/WhySolutionsFail';
import { MechanismSection } from './components/MechanismSection';
import { ProductReveal } from './components/ProductReveal';
import { TransformationSection } from './components/TransformationSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { BonusSection } from './components/BonusSection';
import { OfferSummary } from './components/OfferSummary';
import { GuaranteeSection } from './components/GuaranteeSection';
import { UrgencySection } from './components/UrgencySection';
import { FaqSection } from './components/FaqSection';
import { FooterSection } from './components/FooterSection';
import { SalesNotification } from './components/SalesNotification';
export function App() {
  return <div className="w-full min-h-screen bg-dark-navy text-warm-cream" data-id="element-0">
      <SalesNotification data-id="element-1" />
      <HeroSection data-id="element-2" />
      <OpeningStory data-id="element-3" />
      <ProblemSection data-id="element-4" />
      <WhySolutionsFail data-id="element-5" />
      <MechanismSection data-id="element-6" />
      <ProductReveal data-id="element-7" />
      <TransformationSection data-id="element-8" />
      <TestimonialsSection data-id="element-9" />
      <BonusSection data-id="element-10" />
      <OfferSummary data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <UrgencySection data-id="element-13" />
      <FaqSection data-id="element-14" />
      <FooterSection data-id="element-15" />
    </div>;
}